import { define, Record } from "type-r";

@define
export default class ValidRecord extends Record {
    validCheck(attrName: string): boolean | string {
        if (this.isValid(attrName))
            return true;
        let err = this.getValidationError(attrName)
        return err.toString()
    }
}